import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getProducts = createAsyncThunk(
  "Product/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(`${API_URL.ITEM.SLUG}?${queryString}`);
      // const product_list = data.data.list;
      // return { product_list };
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createProduct = createAsyncThunk(
  "Product/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.ITEM.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const deleteProduct = createAsyncThunk(
  "Product/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.ITEM.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const editProduct = createAsyncThunk(
  "Product/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API_URL.ITEM.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const getProductOverview = createAsyncThunk(
  "ProductOverview/get",
  async (itemId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.ITEM.SLUG}/${itemId}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const discontinuedProduct = createAsyncThunk(
  "ProductDiscontinued/put",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.ITEM.SLUG}/Discontinue`,
        payload,
      );
      dispatch(getProductOverview(payload?.itemId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const updateStatusProduct = createAsyncThunk(
  "UpdateProductStatus/put",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.ITEM.SLUG}/UpdateStatus/${id}`,
      );
      dispatch(getProductOverview(id));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const getProductImages = createAsyncThunk(
  "Images/get",
  async (itemId, { rejectWithValue }) => {
    try {
      const data = await axios.get(`${API_URL.ITEM.SLUG}/${itemId}/Images`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const uploadImage = createAsyncThunk(
  "UploadImage/post",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const itemId = payload?.itemId;
      const { data } = await axios.post(
        `${API_URL.ITEM.SLUG}/${itemId}/Image`,
        payload?.formData,
      );
      dispatch(getProductImages(itemId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const deleteProductImage = createAsyncThunk(
  "Delete/delete",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const itemId = payload?.itemId;
      const imageId = payload?.imageId;
      const data = await axios.delete(`${API_URL.ITEM.SLUG}/Image/${imageId}`);
      dispatch(getProductImages(itemId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const addItemToGroup = createAsyncThunk(
  "addItemToGroup/post",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.ITEM_GROUP.ADD_ITEM_GROUP}`,
        payload,
      );
      dispatch(getProductOverview(payload?.itemId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const removeItemFromGroup = createAsyncThunk(
  "removeItemFromGroup/post",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.ITEM_GROUP.REMOVE_ITEM_FROM_GROUP}`,
        payload,
      );
      dispatch(getProductOverview(payload?.itemId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const moveItemToAnotherGroup = createAsyncThunk(
  "moveItemToAnotherGroup/post",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.ITEM_GROUP.MOVE_ITEM_TO_ANOTHER_GROUP}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

// Fetch item location configuration
export const getItemLocations = createAsyncThunk(
  "ItemLocations/get",
  async (itemId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_URL.ITEM.ITEM_LOCATION(itemId));
      return data.data || data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Fetch stock summary for item
export const getStockSummary = createAsyncThunk(
  "StockSummary/get",
  async (itemId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.STOCK.SUMMARY}?itemId=${itemId}`,
      );
      return data.data || data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Create opening stock
export const createOpeningStock = createAsyncThunk(
  "OpeningStock/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(API_URL.OPENING_STOCK.SLUG, payload);
      return data.data || data;
    } catch (error) {
      return rejectWithValue(error.data || error);
    }
  },
);

// Bulk import items
export const bulkImportItems = createAsyncThunk(
  "product/bulkImportItems",
  async ({ file, templateId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const url = templateId
        ? `${API_URL.ITEM.BULK_IMPORT}?templateId=${templateId}`
        : API_URL.ITEM.BULK_IMPORT;

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 5 * 60 * 1000, // 5 minutes for large files
      });

      const data = response?.data;
      // if (!data) {
      //   return rejectWithValue({ message: "No response from server. The file may be too large.", errors: [] });
      // }

      // // Check for business-level failure (API returns 200 but has validation errors)
      // if (data.data && data.data.errors && data.data.errors.length > 0) {
      //   return rejectWithValue(data.data);
      // }

      return data.data;
    } catch (error) {
      // Handle network errors (no response from server)
      if (!error?.data && !error?.response) {
        return rejectWithValue({
          message:
            error?.message ||
            "Network error. The file may be too large or the server timed out.",
          errors: [],
        });
      }
      // error.data is the response body: { data: { errors: [...], message: "..." }, isSuccess: true }
      // We need to pass error.data.data to get the inner object with errors
      const errorPayload = error?.data?.data || error?.data || error;
      return rejectWithValue(errorPayload);
    }
  },
);

// Bulk import item default bins
export const bulkImportItemDefaultBins = createAsyncThunk(
  "product/bulkImportItemDefaultBins",
  async (
    { file, templateId, locationId, warehouseId, transferStock, isDryRun },
    { rejectWithValue, dispatch, getState },
  ) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const params = new URLSearchParams();
      if (templateId) params.append("templateId", templateId);
      if (locationId) params.append("locationId", locationId);
      if (warehouseId) params.append("warehouseId", warehouseId);
      if (transferStock) params.append("transferStock", "true");
      if (transferStock && isDryRun) params.append("isDryRun", "true");

      const queryString = params.toString();
      const url = queryString
        ? `${API_URL.ITEM.BULK_IMPORT_DEFAULT_BINS}?${queryString}`
        : API_URL.ITEM.BULK_IMPORT_DEFAULT_BINS;

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 5 * 60 * 1000,
      });

      const data = response?.data;
      if (!data) {
        return rejectWithValue({
          message: "No response from server. The file may be too large.",
          errors: [],
        });
      }

      if (data.data && data.data.errors && data.data.errors.length > 0) {
        return rejectWithValue(data.data);
      }

      return data.data;
    } catch (error) {
      if (!error?.data && !error?.response) {
        return rejectWithValue({
          message:
            error?.message ||
            "Network error. The file may be too large or the server timed out.",
          errors: [],
        });
      }
      const errorPayload = error?.data?.data || error?.data || error;
      return rejectWithValue(errorPayload);
    }
  },
);

// Get bulk import history for items
export const getItemBulkImportHistory = createAsyncThunk(
  "product/getItemBulkImportHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.post(
        `${API_URL.ITEM.BULK_IMPORT_HISTORY}?${queryString}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

// Bulk import opening stock
export const bulkImportOpeningStock = createAsyncThunk(
  "product/bulkImportOpeningStock",
  async (
    { file, locationId, warehouseId, templateId },
    { rejectWithValue },
  ) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const params = new URLSearchParams();
      params.append("locationId", locationId);
      if (warehouseId) params.append("warehouseId", warehouseId);
      if (templateId) params.append("templateId", templateId);

      const url = `${API_URL.OPENING_STOCK.BULK_IMPORT}?${params.toString()}`;

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 5 * 60 * 1000,
      });

      return response?.data?.data;
    } catch (error) {
      if (!error?.data && !error?.response) {
        return rejectWithValue({
          message:
            error?.message ||
            "Network error. The file may be too large or the server timed out.",
          errors: [],
        });
      }
      const errorPayload = error?.data?.data || error?.data || error;
      return rejectWithValue(errorPayload);
    }
  },
);

// Get opening stock bulk import history
export const getOpeningStockBulkImportHistory = createAsyncThunk(
  "product/getOpeningStockBulkImportHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => params.append(key, item));
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.post(
        `${API_URL.OPENING_STOCK.BULK_IMPORT_HISTORY}?${queryString}`,
        {},
        { headers: { "Content-Type": "application/json" } },
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

// Export items to Excel
export const exportItemsToExcel = createAsyncThunk(
  "product/exportItemsToExcel",
  async (payload, { rejectWithValue }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        )
      );

      const response = await axios.post(
        API_URL.ITEM.EXPORT_EXCEL,
        filteredPayload,
        {
          responseType: "blob",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
        }
      );

      // Create download link
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Items_${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const productSlice = createSlice({
  name: "product",
  initialState: {
    product_list: [],
    current_values: null,
    active_payload: null,
    total_records: 0,
    loading: false,
    product_overview: null,
    product_images: [],
    item_locations: [],
    stock_summary: [],
    locations_loading: false,
    bulk_import_history: [],
    opening_stock_import_history: [],
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
      state.product_list = [];
    },
    resetProductDetail(state) {
      state.product_overview = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.product_list = action.payload.data.list;
        state.total_records = action.payload.data.totalRecords || 0;
        state.loading = false;
      })
      .addCase(getProducts.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(createProduct.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createProduct.rejected, (state) => {
        state.loading = false;
      })
      .addCase(editProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(editProduct.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editProduct.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProduct.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteProduct.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getProductOverview.fulfilled, (state, action) => {
        state.product_overview = action.payload;
      })
      .addCase(getProductImages.fulfilled, (state, action) => {
        state.product_images = action.payload.data;
      })
      .addCase(getItemLocations.pending, (state) => {
        state.locations_loading = true;
      })
      .addCase(getItemLocations.fulfilled, (state, action) => {
        state.item_locations = action.payload || [];
        state.locations_loading = false;
      })
      .addCase(getItemLocations.rejected, (state) => {
        state.item_locations = [];
        state.locations_loading = false;
      })
      .addCase(getStockSummary.pending, (state) => {
        state.locations_loading = true;
      })
      .addCase(getStockSummary.fulfilled, (state, action) => {
        state.stock_summary = action.payload || [];
        state.locations_loading = false;
      })
      .addCase(getStockSummary.rejected, (state) => {
        state.stock_summary = [];
        state.locations_loading = false;
      })
      .addCase(getItemBulkImportHistory.fulfilled, (state, action) => {
        state.bulk_import_history = action.payload.list || [];
      })
      .addCase(getOpeningStockBulkImportHistory.fulfilled, (state, action) => {
        state.opening_stock_import_history = action.payload.list || [];
      })
      .addCase(exportItemsToExcel.pending, (state) => {
        state.loading = true;
      })
      .addCase(exportItemsToExcel.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(exportItemsToExcel.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  setCurrentValues,
  setActivePayload,
  resetCurrentValue,
  resetProductDetail,
} = productSlice.actions;
export default productSlice.reducer;
